import { Dispatch } from "redux";
import { updateAxnAdminUserInvitationRequest } from "@requests/axnadmin-core";
import { AxnAdminUserPropertyBundle } from "@idw-types/data/axn-admin-user-property-bundle";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { FormattedAxnAdminUserInvitation } from "@idw-types/data/axn-admin-user-invitation";
import { setOrganizationInvitationDetails } from "@redux/actions/organization-invitation-details-actions";
import { formatAxnAdminUserInvitation } from "@formatters/axn-admin-user-invitations/axn-admin-user-invitation-formatter";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const updateOrganizationInvitationDetailsReduxRequest = (dispatch: Dispatch) => async (
    axnAdminUserInvitation: FormattedAxnAdminUserInvitation,
    axnAdminUserPropertyBundles: Array<AxnAdminUserPropertyBundle>,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
) => {
    const { data, error, body } = await updateAxnAdminUserInvitationRequest(axnAdminUserInvitation);
    if (data?.transferObject) {
        const formattedAxnAdminUserInvitation = formatAxnAdminUserInvitation(
            data.transferObject,
            axnAdminUserPropertyBundles,
            axnCompanies,
            axnRelyingParties
        );
        dispatch(setOrganizationInvitationDetails({
            ...formattedAxnAdminUserInvitation,
            permissions: axnAdminUserInvitation.permissions
        }));
        displaySuccessModal(
            dispatch,
            resources.requests.updateOrganizationInvitationDetails.success.title,
            resources.requests.updateOrganizationInvitationDetails.success.message
        );
        return formattedAxnAdminUserInvitation;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateOrganizationInvitationDetails.error.title,
            resources.requests.updateOrganizationInvitationDetails.error.message,
            error,
            null,
            body
        );
    }

    return null;
};